module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.changeResult != '') ? _c('p', [_vm._v(_vm._s(_vm.changeResult))]) : _vm._e(), _vm._v(" "), _c('form', {
    staticStyle: {
      "max-width": "300px",
      "min-width": "100px",
      "margin": "0 0"
    },
    attrs: {
      "name": "ChangePasswordForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.tryChangePassword.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "section form-input-validate"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPassword),
      expression: "oldPassword"
    }],
    staticClass: "txbox __l",
    attrs: {
      "type": "password",
      "name": "oldpassword",
      "placeholder": _vm.$t('placeholder.Reenter old password'),
      "required": "required"
    },
    domProps: {
      "value": (_vm.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "section form-input-validate"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "txbox __l",
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": _vm.$t('placeholder.Enter new password'),
      "required": "required"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "section btn __l __block",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('br')])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c8296ce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/ChangePasswordPage.vue
// module id = 358
// module chunks = 1